<template>
    <div class="page" v-if="currentPage && !!!$apollo.loading">
        
          <component :is="customComponent" :page="currentPage" :parent="parent" v-if="!!customComponent"></component>
  
          <template v-else>
              <slot name="header">
                  <div class="uk-section uk-section-default uk-background-legible uk-background-cover uk-background-fixed uk-background-blend-multiply uk-padding-large hero" v-bind:style="{ backgroundImage: `url(${currentPage.heroImage.large4x3})`}" v-if="!!currentPage.heroImage && currentPage.heroImage.id > 0">
                      <div class="uk-grid uk-margin-xlarge-top" uk-grid>
                          <div class="uk-light uk-width-1-2@l uk-width-3-5@m uk-width-1-1@xs uk-margin-xlarge-bottom">
  
                              <router-link :to="parent.link" v-if="parent"><label>{{parent.menuTitle}}</label></router-link>
                              <h1 class="uk-margin-small-top">{{currentPage.title}}</h1>
  
                              <slot name="summary">
                                  <p class="uk-text-lead" v-if="currentPage.summary">{{currentPage.summary}}</p>
                              </slot>
  
                              <slot name="subheader"></slot>
  
                        </div>
                      </div>
                  </div>
                  <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header" v-else>
                    <div class="uk-light uk-container uk-container-small uk-text-center">
  
                        <router-link :to="parent.link" v-if="parent"><label>{{parent.menuTitle}}</label></router-link>
                        <h1 class="uk-margin-small-top">{{currentPage.title}}</h1>
  
                        <slot name="summary">
                            <p class="uk-text-lead" v-if="currentPage.summary">{{currentPage.summary}}</p>
                        </slot>
  
                        <slot name="subheader"></slot>
                    </div>
                  </div>
              </slot>
  
              <slot name="top">
                  <CTA :feature="currentPage.topFeature" v-if="currentPage.topFeature && currentPage.topFeature.id > 0" />
              </slot>
  
              <slot name="default">
                  <div class="uk-section uk-section-medium uk-background-white">
                      <div class="uk-container uk-container-small">
                          <div class="content" v-html="currentPage.content"></div>
  
                          <div class="subpages" v-if="currentPage.subpages">
                              <div v-for="subpage in currentPage.subpages">
                                  {{subpage.title}}
                              </div>
                          </div>
  
                      </div>
                  </div>
  
              </slot>
  
              <div class="uk-section uk-section-medium uk-background-muted uk-light" v-if="currentPage.secondaryContent">
                  <div class="uk-container uk-container-small">
                      <div class="content" v-html="currentPage.secondaryContent"></div>
                  </div>
              </div>
  
              <Testimonials :testimonials="(currentPage && currentPage.testimonialsArray) ? JSON.parse(currentPage.testimonialsArray, true) : false" />
  
              <slot name="bottom">
                  <CTA :feature="currentPage.bottomFeature" v-if="currentPage.bottomFeature && currentPage.bottomFeature.id > 0" />
              </slot>
          </template>
  
      
  
    </div>
  </template>
  
  <script>
  import _ from 'lodash'
  import gql from 'graphql-tag'
  
  import CTA from '../components/CTA.vue'

  
  // GraphQL query
  const currentPageQuery = gql`
      query($url: String!) {
          readOnePage(filter: { fullPath: { eq: $url }}) {
              id
              content
              link
              renderComponent
              secondaryContent
              subtitle
              summary
              testimonialsArray
              title
              urlSegment
              heroClass
              image {
                  id
                  small
                  smallSquare
                  medium
              }
              heroImage {
                  id
                  medium
                  large
                  large4x3
              }
              parent {
                  __typename
                  ... on SiteTree {
                      title
                      menuTitle
                      link
                  }
                  ... on RedirectorPage {
                      title
                      menuTitle
                      link
                  }
                  ... on Page {
                      title
                      menuTitle
                      link
                  }
                  ... on PeoplePage {
                      title
                      menuTitle
                      link
                  }
                  ... on Fellow {
                      title
                      menuTitle
                      link
                  }
                  ... on Newsroom {
                      title
                      menuTitle
                      link
                  }
                  ... on Competition {
                      title
                      menuTitle
                      link
                  }
              }
              subnav {
                  edges {
                      node {
                          subnavTitle
                          link
                      }
                  }
              }
              subpages {
                  edges {
                      node {
                          menuTitle
                          link
                      }
                  }
              }
              topFeature{
                  id
                  cssClass
                  heading
                  body
                  buttonClass
                  buttonLabel
                  link
                  openInNew
                  image {
                      id
                      large16x9
                  }
              }
              bottomFeature{
                  id
                  cssClass
                  heading
                  body
                  buttonClass
                  buttonLabel
                  link
                  openInNew
                  image {
                  id
                  large16x9
                  }
              }
          }
      }
  `
  
  export default {
      inject: ['theme', 'state'],
      props: ['customParent', 'customSummary'],
      components: {
          CTA
      },
      data() {
          return {
              readOnePage: {},
              hero: false,
              loading: 0
          }
      },
      apollo: {
          $query: {
              loadingKey: 'loading',
          },
          currentPage: {
              query: currentPageQuery,
              variables() {
                  return {
                      url: this.$route.path
                  }
              },
              result(result) {
  
                  if(result.loading || !result.data ) { return; }
  
                //   console.log('result', result);
  
                  if(!result.data.readOnePage) {
                      this.state.api.subnav=[]
                      this.$router.push("/404")
                  }
                  else {
                    //   console.log('page loads', result.data.readOnePage.subnav)
                      if(result.data.readOnePage.subnav && result.data.readOnePage.subnav?.edges.length) {
                          let items = []
                          _.each(result.data.readOnePage.subnav.edges, (item) => {
                              items.push({
                                  title: item.node.subnavTitle,
                                  link: item.node.link
                              })
                          })
                          this.state.api.subnav = items
                      }
                      else {
                          this.state.api.subnav=[]
                      }
  
                      if(result.data.title) {
                          this.state.setMetaTitle(result.data.readOnePage.title)
                      }
                  }
  
                  return
              },
              error(error) {
                  console.log('eror', error);
                  this.$router.push("/404")
              },
              update(data) {
                return data.readOnePage
              }
          }
      },
      computed: {
          parent() {
              if(this.customParent) {
                  return this.customParent
              }
              if(this.currentPage.parent) {
                  return this.currentPage.parent
              }
          },
          customComponent() {
              if(this.currentPage.renderComponent!='Page') {
                  return this.currentPage.renderComponent
              }   
          }
      }
  }
  
  </script>
  